/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTableNew.scss';

import React from 'react';
import {lastBusinessDay} from "../../../utils/dashboard-utils";
import {useSelector} from "react-redux";
import { getRMDSummary } from '../../../redux/modules/RMD/RMDSetting.selectors';

const TableHeaderNew = (props) => {

  let name;
  const rmdSummaryInfo = useSelector(getRMDSummary);
  const { preRMDEligible } = rmdSummaryInfo;
  props.retirementPlans.agreementTypeName === 'ROLLOVER_IRA'
    ? name = 'Rollover IRA' : props.retirementPlans.agreementTypeName === 'SEP_IRA'
      ? name = 'SEP IRA': props.retirementPlans.agreementTypeName === 'RETIREMENT_PLAN_401K'
        ? name = 'Retirement Plan 401K': name = 'Traditional IRA';
    if (props) {
      if (!preRMDEligible) {
        if (props.showYTDColumns) {
          return (
            <thead>
            <tr className="columns ">
              <th className="name">{name}</th>
              <th className="account">Account</th>
              <th className="account-balance">
                <div>{lastBusinessDay(props.currentRmdYear)}</div>
                Account Balance
              </th>
              <th className="year-rmd">{props.currentRmdYear} RMD</th>
              <th className="distributions-ytd">YTD Distributions</th>
              <th className="remaining-year">Remaining for the year</th>
              <th className="tax-ytd">YTD Tax Withholding</th>
            </tr>
            </thead>
          );
        }
        return (
          <thead>
          <tr className="columns ">
            <th className="name">{name}</th>
            <th className="account">Account</th>
            <th className="account-balance">
              <div>{lastBusinessDay(props.currentRmdYear)}</div>
              Account Balance
            </th>
            <th className="year-rmd">{props.currentRmdYear} RMD</th>
          </tr>
          </thead>
        );
      } else {
        return (
          <thead>
          <tr className="columns ">
            <th className="name">{name}</th>
            <th className="account">Account</th>
            <th className="account-balance">
              Account Balance
            </th>
          </tr>
          </thead>
        );
      }
    }
    return null;
};

export default TableHeaderNew;